import React from 'react'
import Loader from '../Components/Loader'
import * as R from 'ramda'
import { Alert } from '@mui/material'
import i18n from '../../i18n'

export const withLoader = (Component, condition, mode, loaderProps={}) => {
  const props = mode === 'overlay' ? { overlay: true } : { minHeight: '200px' }
  return condition ? <Loader {...props} {...loaderProps} /> : R.type(Component) === 'Function' ? Component() : Component
}

export const withMissingData = (Component, condition) => {
  return condition ? <Alert>{i18n.t('common:ui.MissingData')}</Alert> : R.type(Component) === 'Function' ? Component() : Component
}
